import { ActivityLevelBadge } from "@common/chapters/ActivityLevelBadge"
import { IconImageM } from "@common/components/icons/IconsM"
import { ProgressBarM } from "@common/components/progress/ProgressBarM"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import { DimensionsContext } from "@common/utils/mobileUtils"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import React, { useContext, useEffect, useState } from "react"
import { TouchableOpacity, View } from "react-native"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { connect } from "react-redux"

const ChapterItemComponent = (props) => {
    const {
        chapter,
        onPress = () => {},
        animated = false,
        isHighlighted = false,
        liveReportMode = false,
        validatedActivities = 0,
        todoActivities = 0,
        style,
        withParentChapter = false,
        renderChapterOnly = false,
        interviewReportMode = false,
        width = null,
        label = null,
        // Study-program / activity-generation context: keep the progress bar but
        // drop the exercise-level chip and the XP numbers above the bar — they
        // add clutter and waste vertical space in that dense list.
        hideLevelBadge = false,
        hideProgressNumbers = false,
    } = props

    const dimensions = useContext(DimensionsContext)
    const schoolSubject = props.schoolSubjects?.find(
        (subject) =>
            subject.id?.toString() === chapter?.school_subject_id?.toString()
    )

    const color = schoolSubject?.color ?? theme.colors.info

    const xpTotal = chapter?.xp_total

    const xpMax = Math.max(props.xpToValidateChapter ?? 350, xpTotal)
    const widthMax = width
        ? width
        : liveReportMode
        ? dimensions.width - 100
        : dimensions.width - 40

    const xpTotalWidth = (xpTotal / xpMax) * widthMax

    const level = chapter?.student_chapters?.[0]?.level ?? chapter?.level

    //Animation setup
    const [triggerAnimation, setTriggerAnimation] = useState(false)

    useEffect(() => {
        if (animated) {
            setTimeout(() => {
                setTriggerAnimation(true)
            }, 500)
        }
    }, [])

    const chapterItemComponentContent = () => (
        <View style={{ width: widthMax, alignSelf: "center" }}>
            {label && (
                <TextM
                    color={theme.colors.primary}
                    wrap
                    fontWeight={"Medium"}
                    fontSize={12}
                    style={{ marginBottom: 2 }}
                >
                    {label}
                </TextM>
            )}
            <View
                style={{
                    backgroundColor: isHighlighted
                        ? theme.colors.primaryLighter
                        : theme.colors.white,
                    borderWidth: 1,
                    borderColor: isHighlighted
                        ? theme.colors.primary
                        : theme.colors.lightMore,
                    alignSelf: "center",
                    borderRadius: 10,
                    width: widthMax,
                    marginTop: label ? 0 : (liveReportMode ? 20 : 10),
                    paddingHorizontal: 10,
                    paddingTop: 15,
                    paddingBottom: 0,
                    ...style,
                }}
            >
            <View
                style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                }}
            >
                <View
                    style={{
                        flexDirection: "row",
                        alignItems: "center",
                        marginBottom: 10,
                    }}
                >
                    {schoolSubject?.icon && (
                        <IconImageM
                            uri={schoolSubject?.icon}
                            width={60}
                            style={{}}
                        />
                    )}
                    <View
                        style={{
                            marginLeft: 10,
                            maxWidth: widthMax - 60 - 10 * 2 - 10,
                        }}
                    >
                        <TextM
                            color={color}
                            fontWeight={"SemiBold"}
                            fontSize={17}
                            wrap
                        >
                            {chapter?.name}
                        </TextM>
                        {withParentChapter && (
                            <TextM fontSize={11} fontWeight={"SemiBold"} wrap>
                                {chapter?.parent_chapter?.name
                                    ? chapter?.parent_chapter?.name + " - "
                                    : ""}
                                {schoolSubject?.name} - {chapter?.class}
                            </TextM>
                        )}
                        {liveReportMode && (
                            <TextM fontSize={11} fontWeight={"SemiBold"} wrap>
                                {schoolSubject?.name}
                            </TextM>
                        )}
                        {level && chapter?.id && !renderChapterOnly && !hideLevelBadge && (
                            <ActivityLevelBadge level={level} />
                        )}
                    </View>
                </View>
            </View>
            {liveReportMode && (
                <View
                    style={{
                        alignItems: "flex-start",
                        justifyContent: "center",
                        marginBottom: 15,
                        alignSelf: "flex-start",
                    }}
                >
                    {validatedActivities > 0 && (
                        <TextM
                            color={theme.colors.success}
                            fontWeight={"SemiBold"}
                            wrap
                            fontSize={12}
                        >
                            {"+" +
                                validatedActivities +
                                (validatedActivities > 1
                                    ? " travaux"
                                    : " travail") +
                                " envoyé" +
                                (validatedActivities > 1 ? "s" : "")}
                        </TextM>
                    )}
                    {todoActivities > 0 ? (
                        <TextM
                            color={theme.colors.accent}
                            fontWeight={"SemiBold"}
                            wrap
                            fontSize={12}
                        >
                            {"+" +
                                todoActivities +
                                (todoActivities > 1 ? " travaux" : " travail") +
                                " à faire"}
                        </TextM>
                    ) : validatedActivities > 0 && interviewReportMode ? (
                        <TextM
                            color={theme.colors.success}
                            fontWeight={"SemiBold"}
                            wrap
                            fontSize={15}
                        >
                            OBJECTIF ATTEINT ✅
                        </TextM>
                    ) : null}
                </View>
            )}
            {!renderChapterOnly && (
                <View
                    style={{
                        width: widthMax,
                        height: 15,
                        backgroundColor: theme.colors.lighter,
                        alignSelf: "center",
                        marginTop: hideProgressNumbers ? 4 : 15,
                        borderLeftWidth: 1,
                        borderRightWidth: 1,
                        borderColor: isHighlighted
                            ? theme.colors.primary
                            : theme.colors.lightMore,
                        borderBottomRightRadius: 9,
                        borderBottomLeftRadius: 9,
                    }}
                >
                    {!!xpTotal && !hideProgressNumbers && (
                        <View
                            style={{
                                flexDirection: "row",
                                position: "absolute",
                                top: -16,
                                left: 10,
                            }}
                        >
                            <TextM fontSize={12} fontWeight={"SemiBold"}>
                                {chapter?.xp_gained ?? 0}
                                <TextM fontSize={10}>{" /" + xpTotal} </TextM>
                            </TextM>
                        </View>
                    )}
                    {!!xpTotalWidth && (
                        <View
                            style={{
                                flexDirection: "row",
                                position: "absolute",
                                height: "100%",
                                width: xpTotalWidth - 2,
                                justifyContent: "space-between",
                            }}
                        >
                            {barsElements}
                        </View>
                    )}
                    {!!xpTotalWidth && (
                        <View
                            style={{
                                position: "absolute",
                                width: xpTotalWidth,
                                height: "100%",
                                borderBottomLeftRadius: 9,
                                alignItems: "flex-end",
                                justifyContent: "center",
                            }}
                        >
                            <FontAwesome5
                                solid
                                name="flag"
                                size={18}
                                color={
                                    todoActivities > 0
                                        ? theme.colors.accent
                                        : theme.colors.success
                                }
                                style={{
                                    top: -17,
                                    position: "absolute",
                                    right: -14.5,
                                }}
                            />
                            <View
                                style={{
                                    backgroundColor:
                                        todoActivities > 0
                                            ? theme.colors.accent
                                            : theme.colors.success,
                                    width: 2.4,
                                    height: "100%",
                                }}
                            ></View>
                        </View>
                    )}
                </View>
            )}
            </View>
        </View>
    )

    const barsElements = chapter?.xp_gained_steps
        ?.map((stepXp, index) => {
            const firstNewIndex =
                chapter?.xp_gained_steps?.length - validatedActivities
            const hasNew = validatedActivities > 0

            const barColor = !hasNew
                ? liveReportMode
                    ? theme.colors.successGray
                    : theme.colors.success
                : index >= firstNewIndex
                ? theme.colors.success
                : theme.colors.successGray
            const barWidth = (stepXp / xpMax) * widthMax - 2

            const isLast =
                index === chapter?.xp_gained_steps?.length - 1 &&
                chapter?.xp_remaining_steps?.length === 0
            const isTotalMax = xpTotal === xpMax

            return (
                <View
                    key={index}
                    style={{
                        alignItems: "center",
                        flexDirection: "row",
                    }}
                >
                    {animated &&
                    index === chapter?.xp_gained_steps?.length - 1 ? (
                        <ProgressBarM
                            noText
                            progressColor={barColor}
                            barWidth={barWidth}
                            barStyle={{
                                height: "100%",
                                borderRadius: 0,
                                borderBottomLeftRadius: index === 0 ? 9 : 0,
                                borderBottomRightRadius:
                                    isLast && isTotalMax ? 9 : 0,
                                marginRight: 0,
                            }}
                            style={{ marginTop: 0 }}
                            previousCount={0}
                            canStartAnimation={triggerAnimation}
                            withAnimation={true}
                            count={100}
                            total={100}
                        />
                    ) : (
                        <View
                            style={{
                                backgroundColor: barColor,
                                width: barWidth,
                                height: "100%",
                                borderBottomLeftRadius: index === 0 ? 9 : 0,
                                borderBottomRightRadius:
                                    isLast && isTotalMax ? 9 : 0,
                            }}
                        ></View>
                    )}
                </View>
            )
        })
        ?.concat(
            chapter?.xp_remaining_steps?.map((stepXp, index) => {
                const barColor = theme.colors.lightMore
                const barWidth = (stepXp / xpMax) * widthMax - 2

                const isLast = index === chapter?.xp_remaining_steps?.length - 1
                const isTotalMax = xpTotal === xpMax

                return (
                    <View
                        key={index + chapter?.xp_gained_steps?.length}
                        style={{
                            backgroundColor: barColor,
                            flexDirection: "row",
                            alignItems: "center",
                            width: barWidth,
                            height: "100%",
                            borderBottomLeftRadius:
                                index === 0 &&
                                chapter?.xp_gained_steps?.length === 0
                                    ? 9
                                    : 0,
                            borderBottomRightRadius:
                                isLast && isTotalMax ? 9 : 0,
                        }}
                    ></View>
                )
            })
        )

    return props.forceDisabled ? (
        <View style={{}}>{chapterItemComponentContent()}</View>
    ) : (
        <TouchableOpacity
            style={{}}
            onPress={onPress}
            disabled={animated || liveReportMode}
        >
            {chapterItemComponentContent()}
        </TouchableOpacity>
    )
}
const mapStateToProps = (state) => {
    return {
        user: state.data.currentUser?.object,
        schoolSubjects: state.data.staticData?.school_subjects,
        xpToValidateChapter: state.data.staticData?.xp_to_validate_chapter,
        liveSessions: state.data.currentUser?.object?.live_sessions,
        liveSessionId: state.liveMode?.liveSessionId,
        isLiveModeEnabled: state.liveMode?.isLiveModeEnabled,
        materialLevels: state.data?.staticData?.material_levels,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ChapterItemComponent)
